import type CycleAnswerModel from '../../../models/CycleAnswerModel';
import { requestAndParse, requestSuccessful } from '../request';

const getCycleAnswers = async (studyId?: number, participantId?: string) => {
    const route = 'admin/get-cycle-answers';
    const payload = {
        studyId: studyId ? Number(studyId) : undefined,
        participantId: participantId ? Number(participantId) : undefined,
    };

    const response = await requestAndParse(route, payload, 'GET');

    const success = requestSuccessful(response);
    const answers = (response.body?.answers ?? []) as CycleAnswerModel[];
    const columns = (response.body?.columns ?? []) as string[];

    return { success, answers, columns };
};

export default getCycleAnswers;
